"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/28
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanupFileReceiver = exports.cleanupFileSender = exports.getCompletedFile = exports.createFileReceiveFunction = exports.createFileSendFunction = void 0;
// Public API - Main entry points for file operations
var sender_1 = require("./sender");
Object.defineProperty(exports, "createFileSendFunction", { enumerable: true, get: function () { return sender_1.createFileSendFunction; } });
var receiver_1 = require("./receiver");
Object.defineProperty(exports, "createFileReceiveFunction", { enumerable: true, get: function () { return receiver_1.createFileReceiveFunction; } });
var completed_1 = require("./completed");
Object.defineProperty(exports, "getCompletedFile", { enumerable: true, get: function () { return completed_1.getCompletedFile; } });
// Internal API - Used by communication layer for setup/cleanup
var sender_2 = require("./sender");
Object.defineProperty(exports, "cleanupFileSender", { enumerable: true, get: function () { return sender_2.cleanupFileSender; } });
var receiver_2 = require("./receiver");
Object.defineProperty(exports, "cleanupFileReceiver", { enumerable: true, get: function () { return receiver_2.cleanupFileReceiver; } });
//# sourceMappingURL=index.js.map